var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHandshake = function SvgIconHandshake(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m12.545 4.452 3.047 1.382h1.046l2.13-1.065a1.74 1.74 0 0 1 2.331.75l.001.002 2.304 4.41a1.75 1.75 0 0 1-.767 2.382l-2.068 1.03-.976 1.53a1 1 0 0 1-.136.168l-3.45 3.45-.024.024a1.8 1.8 0 0 1-1.607.444l-.01-.003-.021-.005-5.438-1.36-.026-.006a1.75 1.75 0 0 1-.634-.328l-.013-.011-4.662-3.926-2.208-1.109a1.74 1.74 0 0 1-.768-2.373L2.9 5.426a1.75 1.75 0 0 1 2.319-.765l.01.004L7.23 5.667l4.083-1.295.026-.008a1.75 1.75 0 0 1 1.204.087m-.738 1.861 1.693.768.039.753h2.73l2.452 4.688-.755 1.182-3.273 3.273-5.225-1.306-4.085-3.441L7.809 7.58zm-7.246.254 1.206.604-2.073 3.972-1.207-.606zm16.955 4.07-2.073-3.969-1.21.605 2.074 3.967z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.53 17.245a1 1 0 0 0-1.31 1.51l2.114 1.834c.21.185.462.316.734.38l2.812.71a1 1 0 1 0 .49-1.94L7.6 19.042z"
  }))));
};
export default SvgIconHandshake;